import {createContext} from 'react';
const ExpensePaymentContext = createContext();
export default ExpensePaymentContext;